const configValues = {
	BACKEND_SCHEME: 'https://',
	BACKEND: 'at.buggy.ants.house/jsonrpc2/buggy.ants.house/',
	BACKEND_VERSION: 'v1',
	TIMEOUT: 20,
};

export default configValues;